import React, { Component, forwardRef } from "react";
import GridContainer from "../../components/Custom/Grid/GridContainer";
import GridItem from "../../components/Custom/Grid/GridItem";
import MaterialTable from "../../components/MaterialTable";
import CustomTooltip from "../../components/Custom/Tooltip/Tooltip";
import TextField from "@mui/material/TextField";
import SearchIcon from "@material-ui/icons/Search";
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TablePagination,
  Typography,
  withStyles,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import { Alert, Autocomplete } from "@mui/material";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ApiService from "../../ApiService";
import { format } from "date-fns";

const useStyles = (theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  tablewraptext: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  small: {
    width: theme.spacing(7),
    height: theme.spacing(4),
  },
  medium: {
    width: "45px",
    height: "15px",
  },
  chipRoot: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  searchbar: {
    margin: theme.spacing(2),
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  buttonProgress: {
    color: theme.palette.secondary.main,
    position: "absolute",
    marginTop: 8,
    marginLeft: -65,
  },
  crossError: {
    color: theme.palette.error.main,
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
  },
  menuText: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
});

class RejectedTransactionComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      result: [],
      merchants: [],
      open: false,
      loading: false,
      failed: false,
      success: false,
      selectedDate: null,
      merchantTerminals: null,
      terminalId: null,
      merchantId: null,
      errorCode: null,
      orderNoCriteria: null,
      pageNumber: 0,
      responsemessage: null,
      rowPerPage: 20,
      totalRow: 0,
      label: null,
      labelTwo: null,
    };

    this.searchTransactions = this.searchTransactions.bind(this);
  }

  componentDidMount() {
    this.fetchMerchantTerminals();
    this.fetchAllMerchants();
  }

  fetchMerchantTerminals = () => {
    ApiService.fetchMerchantTerminals()
      .then((res) => {
        this.setState({ merchantTerminals: res.data });
      })
      .catch((e) => {});
  };

  fetchAllMerchants = () => {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data });
    });
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleTerminalChange = (event, newValue) => {
    if (newValue) {
      this.setState({
        terminalId: newValue.terminalId,
        label: newValue.label + "-" + newValue.terminalCardType,
      });
    } else {
      this.setState({
        terminalId: null,
        label: null,
      });
    }
  };

  handleMerchantChange = (event, newValue) => {
    if (newValue) {
      this.setState({
        merchantId: newValue,
        labelTwo: newValue.merchantName + "-" + newValue.code,
      });
    } else {
      this.setState({
        merchantId: null,
        labelTwo: null,
      });
    }
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleChangePage(e, pageNo) {
    this.setState({ pageNumber: pageNo });
    this.reloadRejectedTransactions(pageNo);
  }

  getMerchantIdToSubmit() {
    const merId = this.state.merchantId ? this.state.merchantId.id : null;
    return merId;
  }

  reloadRejectedTransactions = (pageNumber) => {
    this.setState({ loading: true });
    const merId = this.getMerchantIdToSubmit();
    ApiService.fetchRejectedTransactions(
      format(this.state.selectedDate, "yyyyMMdd"),
      merId,
      this.state.terminalId,
      this.state.orderNoCriteria,
      this.state.errorCode,
      pageNumber,
      this.state.rowPerPage
    )
      .then((res) => {
        if (res.data.status === "Ok") {
          this.setState({
            totalRow: res.data.totalRow,
            result: res.data.responseObject,
            loading: false,
            failed: false,
            success: true,
            responsemessage: res.data.responseMessage,
          });
          setTimeout(() => {
            this.handleClose();
          }, 3000);
        } else {
          this.setState({
            loading: false,
            failed: true,
            success: false,
            responsemessage: res.data.responseMessage,
          });
        }
      })
      .catch((e) => {
        this.setState({
          loading: false,
          failed: true,
          success: false,
          responsemessage: "Error in fetching Result.",
        });
      });
  };

  handleClose = () => {
    this.setState({
      loading: false,
      open: false,
      responsemessage: "",
      failed: false,
      success: false,
      selectedDate: null,
      terminalId: null,
      merchantId: null,
      errorCode: null,
      orderNoCriteria: null,
      label: null,
      labelTwo: null,
    });
  };

  handleDateChange = (date) => {
    this.setState({ selectedDate: date });
  };

  searchTransactions() {
    this.setState({ pageNumber: 0 });

    if (
      (this.state.selectedDate === null && this.state.terminalId === null) ||
      (this.state.selectedDate === null && this.state.merchantId === null)
    ) {
      this.setState({
        responsemessage:
          "Please select Date. Atleast Select Terminal or Merchant ",
        failed: true,
        open: true,
      });

      return;
    } else if (this.state.selectedDate === null) {
      this.setState({
        responsemessage: "Please select Date ",
        failed: true,
        open: true,
      });
    } else if (
      (this.state.terminalId === null || "") &&
      (this.state.merchantId === null || "")
    ) {
      this.setState({
        responsemessage: "Please select Terminal or Merchant",
        failed: true,
        open: true,
      });
    } else {
      this.setState({ failed: false });
      this.reloadRejectedTransactions(0);
      return;
    }
  }

  tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  render() {
    const { classes } = this.props;

    const { terminalId, merchantTerminals, selectedDate, merchants } =
      this.state;
    return (
      <>
        <Button
          style={{ marginLeft: "90%", marginBottom: "1%" }}
          variant="contained"
          color="primary"
          onClick={this.handleOpen}
        >
          Filter
        </Button>
        <Grid container>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            PaperProps={{ style: { width: "400px", height: "450px" } }}
          >
            {this.state.failed && (
              <Alert
                severity="error"
                elevation={0}
                style={{ marginTop: "1em" }}
              >
                {" "}
                {this.state.responsemessage}
              </Alert>
            )}
            {this.state.success && (
              <Alert severity="success" elevation={0}>
                {" "}
                {this.state.responsemessage}
              </Alert>
            )}
            <DialogTitle>Rejected Transaction Filter</DialogTitle>
            <DialogContent>
              <Typography variant="body2" color="primary">
                Date Selection is mandatory.Either select Terminal or Merchant.
              </Typography>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  value={selectedDate}
                  onChange={this.handleDateChange}
                  format="MM/dd/yyyy"
                  label="Select Date"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={selectedDate === null}
                      helperText={
                        selectedDate === null ? "Please select a date" : ""
                      }
                    />
                  )}
                />
              </MuiPickersUtilsProvider>
              <br />
              {/* <FormControl
              className={classes.formControl}
              style={{ minWidth: "250px", marginTop: "8%" }}
            >
              <InputLabel id="merchantTerminalSelectLabel">Terminal</InputLabel>
              <Select
                value={this.state.terminalId}
                MenuProps={this.TerminalMenuProps}
                onChange={this.handleChange}
                name="terminalId"
                labelId="merchantTerminalSelectLabel"
                id="merchantTerminalSelect"
              >
                <MenuItem key="" value="">
                  &nbsp;{" "}
                </MenuItem>
                {this.state.merchantTerminals &&
                  this.state.merchantTerminals.map((mt) => (
                    <MenuItem key={mt.terminalId} value={mt.terminalId} dense>
                      {mt.label + "-" + mt.terminalCardType}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl> */}
              <Grid item>
                <FormControl
                  className={classes.formControl}
                  style={{ minWidth: "200px", marginTop: "8%" }}
                >
                  <Autocomplete
                    value={this.state.label}
                    id="merchantTerminalSelectLabel"
                    onChange={this.handleTerminalChange}
                    options={merchantTerminals}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option.terminalId}>
                          {option.label + "-" + option.terminalCardType}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Terminals"
                        variant="outlined"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <br />
              <Grid item>
                <FormControl
                  className={classes.formControl}
                  style={{ minWidth: "200px", marginTop: "8%" }}
                >
                  <Autocomplete
                    value={this.state.merchantId}
                    onChange={this.handleMerchantChange}
                    options={merchants}
                    getOptionLabel={(option) =>
                      option ? option.merchantName + "-" + option.code : ""
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        labelId="merchantSelectLabel"
                        label="Merchants"
                        variant="outlined"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <br />
              <TextField
                value={this.state.errorCode}
                style={{ marginTop: "8%" }}
                id="errorCode"
                name="errorCode"
                label="Error code"
                onChange={this.handleChange}
                className={classes.formControl}
              />{" "}
              <br />
              <TextField
                style={{ marginTop: "8%" }}
                value={this.state.orderNoCriteria}
                id="orderNoCriteria"
                name="orderNoCriteria"
                label="Order Number"
                onChange={this.handleChange}
                className={classes.formControl}
              />
            </DialogContent>

            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                startIcon={<SearchIcon />}
                onClick={this.searchTransactions}
              >
                Search
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                onClick={this.handleClose}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>

        <GridContainer style={{ margin: ".1em" }}>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginTop: "4px" }}
          >
            <MaterialTable
              title="Rejected Transactions"
              icons={this.tableIcons}
              options={{
                search: false,
                exportButton: false,
                paginationType: "normal",
                pageSize: this.state.rowPerPage,
                pageSizeOption: [],
                padding: "dense",
                showEmptyDataSourceMessage: true,
                emptyRowsWhenPaging: false,
                selectionProps: false,
              }}
              components={{
                Pagination: (props) => (
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={[]}
                    rowsPerPage={this.state.rowPerPage}
                    count={this.state.totalRow}
                    page={this.state.pageNumber}
                    onChangePage={(e, page) => this.handleChangePage(e, page)}
                  />
                ),
              }}
              columns={[
                {
                  field: "terminalId",
                  title: "Terminal",
                  render: (rowData) => (
                    <CustomTooltip title={rowData.terminalId} copy={true}>
                      <InfoOutlinedIcon />
                    </CustomTooltip>
                  ),
                },
                {
                  field: "merchantId",
                  title: "Merchant Id",
                  render: (rowData) => (
                    <CustomTooltip title={rowData.merchantId} copy={true}>
                      <InfoOutlinedIcon />
                    </CustomTooltip>
                  ),
                },
                {
                  field: "formatCreatedDate",
                  title: "Date",
                  type: "date",
                  render: (rowData) => (
                    <Typography noWrap="true" variant="caption">
                      {rowData.formatCreatedDate}
                    </Typography>
                  ),
                },
                {
                  field: "rejectCode",
                  title: "Error Code",
                  render: (rowData) => (
                    <CustomTooltip title={rowData.rejectCode} copy={true}>
                      <InfoOutlinedIcon />
                    </CustomTooltip>
                  ),
                },

                {
                  field: "merchantOrderNo",
                  title: "Ord No",
                  render: (rowData) => (
                    <CustomTooltip title={rowData.merchantOrderNo} copy={true}>
                      <InfoOutlinedIcon />
                    </CustomTooltip>
                  ),
                },

                {
                  field: "paymentMode",
                  title: "Payment Mode",
                  cellStyle: { fontSize: 11, fontFamily: "sans-serif" },
                },

                {
                  field: "rejectReason",
                  title: "Reject Reason",
                  cellStyle: { fontSize: 11, fontFamily: "sans-serif" },
                },
              ]}
              data={this.state.result}
            />
          </GridItem>
        </GridContainer>
      </>
    );
  }
}

export default withStyles(useStyles)(RejectedTransactionComponent);
